import Rellax from 'rellax'

export default class TestModule {
  constructor(el) { 
    el.bg = el.querySelector('.bg')
    el.rellax = new Rellax(el.bg, { speed: -6})
  }
}